import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Heart, Star, Flower, Squiggle, Sun, Cloud, PaperPlane } from "./Illustrations";
import ContactForm from "./ContactForm";

const hours = [
  { d: "Δευτέρα – Παρασκευή", h: "13:00 – 21:00", color: "#B8D6BE" },
  { d: "Σάββατο", h: "Κλειστά", color: "#FBC4D0" },
  { d: "Κυριακή", h: "Κλειστά", color: "#FBC4D0" },
];

export default function Contact() {
  return (
    <section
      id="epikoinonia"
      data-testid="contact-section"
      className="py-24 md:py-32 bg-brand-cream relative overflow-hidden"
    >
      <Sun className="absolute top-12 left-12 animate-spin-slow opacity-90 hidden md:block" size={80} />
      <Cloud className="absolute top-20 right-1/4 hidden lg:block" size={90} />
      <Heart className="absolute bottom-20 left-1/4 animate-pulse-soft hidden md:block" size={28} color="#FBC4D0" />
      <Flower className="absolute top-1/3 right-8 animate-wiggle hidden lg:block" size={70} color="#FBE4A8" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white border-2 border-brand-blue mb-6 rotate-1">
            <PaperPlane size={20} />
            <span className="font-body text-sm font-bold text-brand-text">
              Επικοινωνία
            </span>
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-brand-text leading-tight">
            Είμαστε εδώ{" "}
            <span className="font-hand text-5xl sm:text-6xl lg:text-7xl text-brand-primary">
              για εσάς
            </span>
            <Heart size={36} className="inline-block ml-2 animate-pulse-soft align-middle" color="#F4A899" />
          </h2>
          <Squiggle className="mx-auto my-5" width={180} color="#B8D6BE" />
          <p className="font-body text-base sm:text-lg text-brand-textSoft leading-relaxed">
            Επικοινωνήστε μαζί μας για οποιαδήποτε ερώτηση ή για να κλείσετε
            ραντεβού αξιολόγησης. Θα μας βρείτε στο Περιστέρι, δίπλα στο μετρό
            Αγίου Αντωνίου — με εύκολη πρόσβαση από όλα τα Δυτικά Προάστια.
          </p>
          <a
            data-testid="contact-call-now-button"
            href="tel:+302105719375"
            className="inline-flex items-center gap-3 mt-8 rounded-full bg-brand-primary hover:bg-brand-primaryHover text-white font-heading font-bold text-lg px-8 py-4 border-3 border-dashed border-white shadow-[0_6px_0_-2px_rgba(91,79,70,0.25)] hover:scale-105 transition-all duration-300 -rotate-1"
          >
            <Phone size={22} strokeWidth={2.4} />
            Καλέστε μας τώρα: 210 571 9375
          </a>
        </div>

        <div className="grid lg:grid-cols-12 gap-6 md:gap-8">
          <a
            data-testid="contact-phone-card"
            href="tel:+302105719375"
            className="lg:col-span-4 -rotate-1 hover:rotate-0 transition-transform duration-500 bg-brand-pinkSoft rounded-[2rem] p-8 border-3 border-dashed border-brand-pink hover:scale-[1.02] shadow-[0_8px_0_-2px_rgba(91,79,70,0.15)] group"
          >
            <div className="w-16 h-16 rounded-2xl bg-brand-pink flex items-center justify-center mb-5 border-2 border-brand-text/20 group-hover:rotate-12 transition-transform">
              <Phone className="text-brand-text" size={26} strokeWidth={2.2} />
            </div>
            <h3 className="font-heading font-bold text-xl text-brand-text mb-1">Τηλέφωνο</h3>
            <p className="font-body text-brand-textSoft text-sm mb-3">Καλέστε μας απευθείας</p>
            <p className="font-heading font-bold text-2xl text-brand-primaryHover">210 571 9375</p>
          </a>

          <a
            data-testid="contact-email-card"
            href="mailto:orizontesanaptixis@hotmail.com"
            className="lg:col-span-4 rotate-1 hover:rotate-0 transition-transform duration-500 bg-brand-yellowSoft rounded-[2rem] p-8 border-3 border-dashed border-brand-yellow hover:scale-[1.02] shadow-[0_8px_0_-2px_rgba(91,79,70,0.15)] group"
          >
            <div className="w-16 h-16 rounded-2xl bg-brand-yellow flex items-center justify-center mb-5 border-2 border-brand-text/20 group-hover:rotate-12 transition-transform">
              <Mail className="text-brand-text" size={26} strokeWidth={2.2} />
            </div>
            <h3 className="font-heading font-bold text-xl text-brand-text mb-1">Email</h3>
            <p className="font-body text-brand-textSoft text-sm mb-3">Στείλτε μας μήνυμα</p>
            <p className="font-heading font-bold text-base text-brand-primaryHover break-all">
              orizontesanaptixis@hotmail.com
            </p>
          </a>

          <div
            data-testid="contact-address-card"
            className="lg:col-span-4 -rotate-1 hover:rotate-0 transition-transform duration-500 bg-brand-secondarySoft rounded-[2rem] p-8 border-3 border-dashed border-brand-secondary hover:scale-[1.02] shadow-[0_8px_0_-2px_rgba(91,79,70,0.15)] group"
          >
            <div className="w-16 h-16 rounded-2xl bg-brand-secondary flex items-center justify-center mb-5 border-2 border-brand-text/20 group-hover:rotate-12 transition-transform">
              <MapPin className="text-brand-text" size={26} strokeWidth={2.2} />
            </div>
            <h3 className="font-heading font-bold text-xl text-brand-text mb-1">Διεύθυνση</h3>
            <p className="font-body text-brand-textSoft text-sm mb-3">Μετρό Αγ. Αντωνίου</p>
            <p className="font-heading font-bold text-lg text-brand-text leading-snug">
              Υψούντος 7<br />
              Περιστέρι, Αθήνα
            </p>
          </div>

          <div
            data-testid="contact-hours-card"
            className="lg:col-span-5 rotate-1 hover:rotate-0 transition-transform duration-500 bg-white rounded-[2rem] p-8 border-3 border-dashed border-brand-blue shadow-[0_8px_0_-2px_rgba(91,79,70,0.15)]"
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="w-14 h-14 rounded-2xl bg-brand-blue flex items-center justify-center border-2 border-brand-text/20">
                <Clock className="text-brand-text" size={24} strokeWidth={2.2} />
              </div>
              <h3 className="font-heading font-bold text-xl text-brand-text">Ωράριο Λειτουργίας</h3>
            </div>
            <div className="space-y-3">
              {hours.map((row) => (
                <div
                  key={row.d}
                  className="flex items-center justify-between py-3 px-4 rounded-2xl"
                  style={{ backgroundColor: row.color + "44" }}
                >
                  <span className="font-body font-bold text-brand-text text-sm sm:text-base">
                    {row.d}
                  </span>
                  <span className="font-heading font-bold text-brand-primaryHover text-sm sm:text-base">
                    {row.h}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div
            data-testid="contact-map-card"
            className="lg:col-span-7 -rotate-1 hover:rotate-0 transition-transform duration-500 rounded-[2rem] overflow-hidden border-3 border-dashed border-brand-purple bg-brand-purpleSoft min-h-[320px] shadow-[0_8px_0_-2px_rgba(91,79,70,0.15)]"
          >
            <iframe
              title="Χάρτης Κέντρου — Ορίζοντες Ανάπτυξης"
              src="https://www.google.com/maps?q=Ypsountos+7,+Peristeri,+Athens&output=embed"
              className="w-full h-full min-h-[320px] border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        <ContactForm />
      </div>
    </section>
  );
}
